import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GetEntityById2GQL } from 'generated/graphql';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { FollowUpTableDialog } from 'entity/dialogs/follow-up-table/follow-up-table.dialog';

@Component({
  selector: 'app-entity-list-row',
  templateUrl: './entity-list-row.component.html',
  styleUrls: ['./entity-list-row.component.scss']
})
export class EntityListRowComponent  {
  @Input() entityId;
  @Input() campaignId;

  @Input() showMergeEntity = false;
  @Input() showQuickActionsButton = false;
  @Input() showRemoveEntity = false;
  @Input() contactButtonsOpensLogContactModal: boolean = true;


  quickActionsMenuOpen = false;

  isMobile$ = this._breakpointObserver.observe(['(min-width: 768px)'])
    .pipe(
      // Invert match to be true if mobile
      map(r => !r.matches)
    );

  private _preFetched = false;

  /**
   * If true toplines component will be hidden using
   * ngIf
   */
  @Input() lazyToplines = false;
  @Output() entityClicked = new EventEmitter<{ campaignId: string; entityId: string }>();

  @Input() expanded: boolean;
  @Output() expandedChange = new EventEmitter<boolean>();

  constructor(
    private _dialog: MatDialog,
    private _getEntityGQL: GetEntityById2GQL,
    private _breakpointObserver: BreakpointObserver
  ) {
  }


  onBasicCardClicked() {
    this.entityClicked.emit({
      campaignId: this.campaignId,
      entityId: this.entityId
    });
  }

  toggleExpanded(event: MouseEvent) {
    event?.stopImmediatePropagation();
    this.expanded = !this.expanded;
    this.expandedChange.emit(this.expanded);
  }

  prefetchToplines() {
    if (this._preFetched || !this.lazyToplines) { return; }
    this._getEntityGQL.fetch({
      entityId: this.entityId,
      campaignId: this.campaignId,
      withToplines: true,
    }, {
      fetchPolicy: 'cache-first'
    }).subscribe(() => this._preFetched = true);
  }

  showFollowUpDetailsClick(event: MouseEvent) {
    event.stopImmediatePropagation();
    FollowUpTableDialog.open(this._dialog, {
      data: { campaignId: this.campaignId, entityId: this.entityId }
    });
  }
}
